import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getProductsAll, getProductByProductID } from '../../api/products';

function MultProd({ productList, setProductList }) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productData, setProductData] = useState([]);

 
  function handleProductMultSelect(selectedOption) {
    if (selectedOption) {
        console.log(selectedOption);
      getProductByProductID(selectedOption.value, (result) => {
        if (result.ok === 1) {
          const data = result.result[0];
          if (productList.some((item) => item.productID === data.productID)) {
            alert("Product already added!");
          } else {
            
            setProductList([...productList, { ...data, price: 0, quantity: 1 }]);
          }
        }
      });
    }
  }

  
  
  function getAllProduct() {
    getProductsAll((result) => {
      if (result.ok === 1) {
        const formattedProducts = result.result.map((item) => ({
          value: item.productID,
          label: item.name,
        }));
        setProductData(formattedProducts);
      }
    });
  }

 
  useEffect(() => {
    getAllProduct();
  }, []);

 
  
  const handlePriceChange = (productID, newPrice) => {
    const updatedList = productList.map((item) => 
      item.productID === productID ? { ...item, price: newPrice } : item
    );
    setProductList(updatedList);
  };

  // Handle quantity change for a product
  const handleQuantityChange = (productID, newQuantity) => {
    const updatedList = productList.map((item) => 
      item.productID === productID ? { ...item, quantity: newQuantity } : item
    );
    setProductList(updatedList);
  };

  // Handle deleting a product from the list
  const handleDeleteProduct = (productID) => {
    const updatedList = productList.filter((item) => item.productID !== productID);
    setProductList(updatedList);
  };


  return (
    <div className="form-group" style={{ marginTop: 40 }}>
      <Select
        className="form-control"
        value={selectedProduct}
        onChange={handleProductMultSelect}
        options={productData}
        placeholder="--Select Product--"
        isSearchable
      />

      <h6 style={{marginTop:20}}>Product Detail</h6>
      {productList.map((item) => (
        <div key={item.productID} style={{ marginBottom: 20 }}>
          <p>
            Name: <span style={{ color: 'black', fontWeight: 'bolder' }}>{item.name}</span>
            <span style={{ color: 'red', marginLeft: 80 }}>
              <button
                onClick={() => handleDeleteProduct(item.productID)}
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                <i className="fa fa-trash"></i>
              </button>
            </span>
          </p>
          
          <p>
            Price: 
            <span style={{ color: 'black', fontWeight: 'bolder' }}>
              <input
                type="number"
                name="price"
                className="form-control"
                value={item.price}
                onChange={(e) => handlePriceChange(item.productID, parseFloat(e.target.value))}
              />
            </span>
          </p>

          <p>
            Quantity: 
            <span style={{ color: 'black', fontWeight: 'bolder' }}>
              <input
                type="number"
                name="quantity"
                className="form-control"
                value={item.quantity}
                onChange={(e) => handleQuantityChange(item.productID, parseInt(e.target.value))}
              />
            </span>
          </p>
        </div>
      ))}
    </div>
  );
}

export default MultProd;
